/**
 * Official brand logos from Simple Icons CDN — free, open-source SVGs.
 * Renders inline so they can be tinted via `color`. Each is a URL with hex tint.
 */
const ICON = (slug, color = 'ffffff') =>
  `https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/${slug}.svg`;

// Simple Icons SVGs are single-color; we serve them as <img> and use CSS filter to tint.
// This keeps everything free + official.

export const OFFICIAL_LOGOS = {
  anthropic: { slug: 'anthropic', label: 'Anthropic' },
  openai: { slug: 'openai', label: 'OpenAI' },
  gemini: { slug: 'googlegemini', label: 'Gemini' },
  stripe: { slug: 'stripe', label: 'Stripe' },
  mongodb: { slug: 'mongodb', label: 'MongoDB' },
  react: { slug: 'react', label: 'React' },
  fastapi: { slug: 'fastapi', label: 'FastAPI' },
  vercel: { slug: 'vercel', label: 'Vercel' },
  cloudflare: { slug: 'cloudflare', label: 'Cloudflare' },
  github: { slug: 'github', label: 'GitHub' },
  google: { slug: 'google', label: 'Google' },
  tailwindcss: { slug: 'tailwindcss', label: 'Tailwind' },
  nodedotjs: { slug: 'nodedotjs', label: 'Node.js' },
  python: { slug: 'python', label: 'Python' },
  typescript: { slug: 'typescript', label: 'TypeScript' },
  elevenlabs: { slug: 'elevenlabs', label: 'ElevenLabs' },
};

/**
 * Render an inline logo (uses <img> + CSS filter to keep the file monochrome white).
 */
export function OfficialLogo({ id, height = 22, tint = '#ffffff', label = true, className = '' }) {
  const meta = OFFICIAL_LOGOS[id];
  if (!meta) return null;
  const src = ICON(meta.slug);
  // Filter to invert to white — simple icons are solid black by default
  const isWhite = tint.toLowerCase() === '#ffffff' || tint.toLowerCase() === '#fff';
  const filter = isWhite ? 'invert(1) brightness(1.2)' : 'none';
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src={src}
        alt={meta.label}
        style={{ height, width: 'auto', filter, opacity: 0.85 }}
        loading="lazy"
        onError={(e) => (e.currentTarget.style.display = 'none')}
      />
      {label && (
        <span className="font-display font-bold text-white/85 tracking-tight whitespace-nowrap">
          {meta.label}
        </span>
      )}
    </span>
  );
}
